module.exports = __webpack_public_path__ + "img/10.ac237835.jpg";